export default "__VITE_ASSET__4794d624__"